import { GROUND_HEIGHT, LEVEL_BACKGROUNDS, backgroundImageCache, loadBackgroundImage } from './constants';

// Ground theme configurations for levels 1-20
const GROUND_THEMES = {
  1: { // Rustic Cobblestone Street (matches dusk brick-city sky)
    name: 'cobblestone_street',
    surface: ['#5a4838', '#4a3828', '#3a2818'],
    curb: '#6a5a48',
    edgeGlow: '#FF9500',
    markings: 'cobblestone',
    details: 'puddles',
    grain: '#4a3828',
  },
  2: { // Urban Alley
    name: 'urban_alley',
    surface: ['#3d3530', '#2e2622', '#201a17'],
    curb: '#5a4a3a',
    edgeGlow: '#FF9500',
    markings: 'cobblestone',
    details: 'puddles',
    grain: '#3a2e26',
  },
  3: { // Desert Sand
    name: 'desert',
    surface: ['#c2a366', '#b08f50', '#9a7b3f'],
    curb: '#8a6b2f',
    edgeGlow: '#FFD700',
    markings: 'none',
    details: 'cracks',
    grain: '#b89955',
  },
  4: { // Desert Highway
    name: 'desert_highway',
    surface: ['#6b5b4a', '#5a4a3a', '#4a3a2a'],
    curb: '#8a7a60',
    edgeGlow: '#FF9500',
    markings: 'road_faded',
    details: 'sand_drifts',
    grain: '#5e4e3e',
  },
  5: { // Industrial Cement
    name: 'cement',
    surface: ['#7a7a7a', '#666666', '#555555'],
    curb: '#888',
    edgeGlow: '#5AC8FA',
    markings: 'hazard',
    details: 'oil_stains',
    grain: '#6e6e6e',
  },
  6: { // Factory Floor
    name: 'factory',
    surface: ['#5a5a5a', '#4a4a4a', '#3a3a3a'],
    curb: '#666',
    edgeGlow: '#FF3B30',
    markings: 'hazard',
    details: 'grates',
    grain: '#505050',
  },
  7: { // Wooden Bridge
    name: 'wooden_bridge',
    surface: ['#8B6B42', '#7A5C36', '#6B4E2C'],
    curb: '#5C3A1E',
    edgeGlow: '#FFD700',
    markings: 'planks',
    details: 'nails',
    grain: '#7A5C36',
  },
  8: { // Dock Planks
    name: 'dock',
    surface: ['#6B5840', '#5A4A35', '#4A3C2A'],
    curb: '#3D2E1E',
    edgeGlow: '#5AC8FA',
    markings: 'planks',
    details: 'rope',
    grain: '#5E4C38',
  },
  9: { // Volcanic Rock
    name: 'volcanic',
    surface: ['#2a1a1a', '#1e1010', '#150a0a'],
    curb: '#3a1a0a',
    edgeGlow: '#FF4500',
    markings: 'none',
    details: 'lava_cracks',
    grain: '#2e1515',
  },
  10: { // Neon Highway
    name: 'neon_highway',
    surface: ['#1a1a2e', '#12122a', '#0a0a20'],
    curb: '#2a2a4e',
    edgeGlow: '#9945FF',
    markings: 'neon_road',
    details: 'holo_strips',
    grain: '#181830',
  },
  11: { // Frozen Tundra
    name: 'ice',
    surface: ['#b8d4e8', '#a0c0d8', '#88aac8'],
    curb: '#d0e8f0',
    edgeGlow: '#00FFFF',
    markings: 'none',
    details: 'ice_cracks',
    grain: '#a8c8dc',
  },
  12: { // Snow Path
    name: 'snow',
    surface: ['#e8e8f0', '#d0d0e0', '#b8b8d0'],
    curb: '#f0f0f8',
    edgeGlow: '#87CEEB',
    markings: 'tire_tracks',
    details: 'footprints',
    grain: '#d8d8e8',
  },
  13: { // Jungle Trail
    name: 'jungle',
    surface: ['#4a5a2a', '#3e4e22', '#33421c'],
    curb: '#2a3a14',
    edgeGlow: '#14F195',
    markings: 'none',
    details: 'roots',
    grain: '#425020',
  },
  14: { // Swamp Mud
    name: 'swamp',
    surface: ['#3a4a2a', '#2e3e20', '#243218'],
    curb: '#1e2a10',
    edgeGlow: '#228B22',
    markings: 'none',
    details: 'bubbles',
    grain: '#344420',
  },
  15: { // Metal Grating
    name: 'metal',
    surface: ['#505860', '#444c54', '#3a4248'],
    curb: '#606870',
    edgeGlow: '#5AC8FA',
    markings: 'grid',
    details: 'rivets',
    grain: '#4a5258',
  },
  16: { // Space Station
    name: 'space',
    surface: ['#1a1a2e', '#141428', '#0e0e22'],
    curb: '#2a2a4e',
    edgeGlow: '#00FFFF',
    markings: 'circuit',
    details: 'lights',
    grain: '#18182a',
  },
  17: { // Castle Stone
    name: 'castle',
    surface: ['#6a6a5a', '#5a5a4a', '#4a4a3a'],
    curb: '#7a7a6a',
    edgeGlow: '#FFD700',
    markings: 'stone_tiles',
    details: 'moss',
    grain: '#5e5e4e',
  },
  18: { // Ruined City
    name: 'ruins',
    surface: ['#4a4a4a', '#3a3a3a', '#2e2e2e'],
    curb: '#555',
    edgeGlow: '#FF3B30',
    markings: 'broken_road',
    details: 'rubble',
    grain: '#404040',
  },
  19: { // Crystal Cavern
    name: 'crystal',
    surface: ['#2a1a3a', '#22142e', '#1a0e24'],
    curb: '#3a2a4a',
    edgeGlow: '#9945FF',
    markings: 'none',
    details: 'crystals',
    grain: '#261838',
  },
  20: { // Final Boss Arena
    name: 'arena',
    surface: ['#1a0a0a', '#120808', '#0a0404'],
    curb: '#2a0a0a',
    edgeGlow: '#FF0000',
    markings: 'ritual',
    details: 'flames',
    grain: '#1e0c0c',
  },
};

const getTheme = (level) => {
  return GROUND_THEMES[Math.min(level, 20)] || GROUND_THEMES[1];
};

// Draw surface texture grain
const drawGrain = (ctx, roadY, canvasWidth, cameraX, theme) => {
  ctx.fillStyle = theme.grain;
  for (let i = 0; i < canvasWidth / 4; i++) {
    const gx = ((i * 47 + cameraX * 0.8) % canvasWidth);
    const gy = roadY + 15 + (i * 23) % (GROUND_HEIGHT - 25);
    ctx.fillRect(gx, gy, 2, 1);
  }
};

// Draw road markings (asphalt lanes)
const drawRoadMarkings = (ctx, roadY, canvasWidth, cameraX) => {
  const offset = cameraX % 80;
  ctx.fillStyle = 'rgba(255, 255, 255, 0.3)';
  for (let i = -1; i < canvasWidth / 80 + 2; i++) {
    ctx.fillRect(i * 80 - (offset % 80), roadY + 30, 50, 2);
    ctx.fillRect(i * 80 - (offset % 80), roadY + GROUND_HEIGHT - 30, 50, 2);
  }
  ctx.fillStyle = '#FFD700';
  const centerY = roadY + GROUND_HEIGHT / 2;
  for (let i = -1; i < canvasWidth / 80 + 2; i++) {
    ctx.fillRect(i * 80 - (offset % 80), centerY - 2, 50, 4);
  }
};

// Draw faded road markings (desert highway)
const drawFadedRoadMarkings = (ctx, roadY, canvasWidth, cameraX) => {
  const offset = cameraX % 120;
  ctx.fillStyle = 'rgba(255, 255, 255, 0.12)';
  const centerY = roadY + GROUND_HEIGHT / 2;
  for (let i = -1; i < canvasWidth / 120 + 2; i++) {
    ctx.fillRect(i * 120 - (offset % 120), centerY - 1, 60, 3);
  }
  ctx.fillStyle = 'rgba(255, 255, 200, 0.08)';
  for (let i = -1; i < canvasWidth / 120 + 2; i++) {
    ctx.fillRect(i * 120 - (offset % 120), roadY + 25, 40, 2);
  }
};

// Draw cobblestone pattern
const drawCobblestone = (ctx, roadY, canvasWidth, cameraX) => {
  const size = 18;
  const offset = cameraX % (size * 2);
  ctx.strokeStyle = 'rgba(0,0,0,0.25)';
  ctx.lineWidth = 1;
  for (let row = 0; row < Math.ceil(GROUND_HEIGHT / size); row++) {
    const rowOffset = row % 2 === 0 ? 0 : size;
    for (let col = -1; col < canvasWidth / (size * 2) + 2; col++) {
      const x = col * size * 2 + rowOffset - offset;
      const y = roadY + 10 + row * size;
      ctx.strokeRect(x, y, size * 2 - 1, size - 1);
    }
  }
};

// Draw wooden planks
const drawPlanks = (ctx, roadY, canvasWidth, cameraX, theme) => {
  const plankW = 80;
  const offset = cameraX % plankW;
  ctx.strokeStyle = 'rgba(0,0,0,0.3)';
  ctx.lineWidth = 2;
  // Horizontal plank lines
  for (let row = 0; row < Math.ceil(GROUND_HEIGHT / 20); row++) {
    const y = roadY + 10 + row * 20;
    ctx.beginPath();
    ctx.moveTo(0, y);
    ctx.lineTo(canvasWidth, y);
    ctx.stroke();
  }
  // Vertical plank gaps
  for (let col = -1; col < canvasWidth / plankW + 2; col++) {
    const x = col * plankW - offset;
    ctx.beginPath();
    ctx.moveTo(x, roadY + 10);
    ctx.lineTo(x, roadY + GROUND_HEIGHT);
    ctx.stroke();
  }
  // Wood grain
  ctx.strokeStyle = 'rgba(0,0,0,0.1)';
  ctx.lineWidth = 1;
  for (let i = 0; i < canvasWidth / 10; i++) {
    const gx = ((i * 31 + cameraX * 0.7) % canvasWidth);
    const gy = roadY + 14 + (i * 17) % (GROUND_HEIGHT - 20);
    ctx.beginPath();
    ctx.moveTo(gx, gy);
    ctx.lineTo(gx + 15 + (i % 5) * 3, gy + (i % 3) - 1);
    ctx.stroke();
  }
};

// Draw hazard stripes (factory/cement)
const drawHazardMarkings = (ctx, roadY, canvasWidth, cameraX) => {
  const stripeW = 40;
  const offset = cameraX % (stripeW * 2);
  // Yellow hazard border at top
  for (let i = -1; i < canvasWidth / stripeW + 2; i++) {
    ctx.fillStyle = i % 2 === 0 ? '#FFD700' : '#1a1a1a';
    ctx.fillRect(i * stripeW - offset, roadY + 10, stripeW, 6);
  }
  // Bottom hazard border
  for (let i = -1; i < canvasWidth / stripeW + 2; i++) {
    ctx.fillStyle = i % 2 === 0 ? '#FFD700' : '#1a1a1a';
    ctx.fillRect(i * stripeW - offset, roadY + GROUND_HEIGHT - 8, stripeW, 6);
  }
};

// Draw neon road (cyberpunk)
const drawNeonRoad = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  const offset = cameraX % 100;
  // Glowing lane strips
  ctx.shadowColor = '#9945FF';
  ctx.shadowBlur = 6;
  ctx.fillStyle = `rgba(153,69,255,${0.4 + Math.sin(t * 2) * 0.2})`;
  for (let i = -1; i < canvasWidth / 100 + 2; i++) {
    ctx.fillRect(i * 100 - (offset % 100), roadY + 28, 60, 2);
    ctx.fillRect(i * 100 - (offset % 100), roadY + GROUND_HEIGHT - 30, 60, 2);
  }
  ctx.fillStyle = `rgba(0,255,255,${0.3 + Math.sin(t * 3) * 0.2})`;
  const cy = roadY + GROUND_HEIGHT / 2;
  for (let i = -1; i < canvasWidth / 100 + 2; i++) {
    ctx.fillRect(i * 100 - (offset % 100), cy - 1, 60, 3);
  }
  ctx.shadowBlur = 0;
};

// Draw circuit board pattern (space station)
const drawCircuitMarkings = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  ctx.strokeStyle = `rgba(0,255,255,${0.2 + Math.sin(t * 2) * 0.1})`;
  ctx.lineWidth = 1;
  const offset = cameraX % 200;
  for (let i = -1; i < canvasWidth / 200 + 2; i++) {
    const bx = i * 200 - offset;
    ctx.beginPath();
    ctx.moveTo(bx, roadY + 20); ctx.lineTo(bx + 40, roadY + 20);
    ctx.lineTo(bx + 40, roadY + 60); ctx.lineTo(bx + 80, roadY + 60);
    ctx.lineTo(bx + 80, roadY + 40); ctx.lineTo(bx + 120, roadY + 40);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(bx + 50, roadY + 100); ctx.lineTo(bx + 90, roadY + 100);
    ctx.lineTo(bx + 90, roadY + 130); ctx.lineTo(bx + 150, roadY + 130);
    ctx.stroke();
  }
};

// Draw stone tile pattern (castle)
const drawStoneTiles = (ctx, roadY, canvasWidth, cameraX) => {
  const tileW = 50;
  const tileH = 30;
  const offset = cameraX % (tileW * 2);
  ctx.strokeStyle = 'rgba(0,0,0,0.3)';
  ctx.lineWidth = 2;
  for (let row = 0; row < Math.ceil(GROUND_HEIGHT / tileH); row++) {
    const rowOff = row % 2 === 0 ? 0 : tileW * 0.5;
    for (let col = -1; col < canvasWidth / tileW + 2; col++) {
      ctx.strokeRect(col * tileW + rowOff - offset, roadY + 10 + row * tileH, tileW - 2, tileH - 2);
    }
  }
};

// Draw metal grid
const drawGrid = (ctx, roadY, canvasWidth, cameraX) => {
  const gridSize = 30;
  const offset = cameraX % gridSize;
  ctx.strokeStyle = 'rgba(100,120,130,0.3)';
  ctx.lineWidth = 1;
  for (let x = -1; x < canvasWidth / gridSize + 2; x++) {
    ctx.beginPath();
    ctx.moveTo(x * gridSize - offset, roadY + 10);
    ctx.lineTo(x * gridSize - offset, roadY + GROUND_HEIGHT);
    ctx.stroke();
  }
  for (let y = 0; y < GROUND_HEIGHT / gridSize; y++) {
    ctx.beginPath();
    ctx.moveTo(0, roadY + 10 + y * gridSize);
    ctx.lineTo(canvasWidth, roadY + 10 + y * gridSize);
    ctx.stroke();
  }
};

// Draw broken road
const drawBrokenRoad = (ctx, roadY, canvasWidth, cameraX) => {
  drawRoadMarkings(ctx, roadY, canvasWidth, cameraX);
  // Cracks
  ctx.strokeStyle = 'rgba(0,0,0,0.4)';
  ctx.lineWidth = 2;
  for (let i = 0; i < 8; i++) {
    const cx = ((i * 197 + cameraX * 0.6) % canvasWidth);
    const cy = roadY + 20 + (i * 67) % (GROUND_HEIGHT - 40);
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + 20 + (i % 3) * 10, cy + 15 - (i % 4) * 5);
    ctx.lineTo(cx + 35, cy + 5);
    ctx.stroke();
  }
};

// Draw tire tracks (snow)
const drawTireTracks = (ctx, roadY, canvasWidth, cameraX) => {
  const offset = cameraX % 40;
  ctx.fillStyle = 'rgba(100,100,120,0.15)';
  for (let i = -1; i < canvasWidth / 40 + 2; i++) {
    const x = i * 40 - offset;
    ctx.fillRect(x, roadY + 50, 12, 8);
    ctx.fillRect(x + 5, roadY + 60, 12, 8);
    ctx.fillRect(x, roadY + 110, 12, 8);
    ctx.fillRect(x + 5, roadY + 120, 12, 8);
  }
};

// Draw ritual markings (final boss)
const drawRitualMarkings = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  const offset = cameraX % 400;
  ctx.strokeStyle = `rgba(255,0,0,${0.3 + Math.sin(t * 2) * 0.15})`;
  ctx.lineWidth = 2;
  for (let i = -1; i < canvasWidth / 400 + 2; i++) {
    const cx = i * 400 - offset + 200;
    const cy = roadY + GROUND_HEIGHT / 2;
    ctx.beginPath();
    ctx.arc(cx, cy, 50, 0, Math.PI * 2);
    ctx.stroke();
    ctx.beginPath();
    for (let p = 0; p < 5; p++) {
      const angle = (p / 5) * Math.PI * 2 - Math.PI / 2;
      const px = cx + Math.cos(angle) * 50;
      const py = cy + Math.sin(angle) * 50;
      const nextAngle = ((p + 2) / 5) * Math.PI * 2 - Math.PI / 2;
      const nx = cx + Math.cos(nextAngle) * 50;
      const ny = cy + Math.sin(nextAngle) * 50;
      ctx.moveTo(px, py);
      ctx.lineTo(nx, ny);
    }
    ctx.stroke();
  }
};

// === Detail drawers ===

const drawManholes = (ctx, roadY, canvasWidth, cameraX) => {
  const spacing = 500;
  const offset = cameraX % spacing;
  for (let m = -1; m < canvasWidth / spacing + 2; m++) {
    const mx = m * spacing - offset + 150;
    const my = (m % 2 === 0) ? roadY + 50 : roadY + GROUND_HEIGHT - 50;
    ctx.fillStyle = '#1a1a1a';
    ctx.beginPath(); ctx.arc(mx, my, 15, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#333'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.arc(mx, my, 12, 0, Math.PI * 2); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(mx - 8, my); ctx.lineTo(mx + 8, my); ctx.stroke();
  }
};

const drawPuddles = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  for (let i = 0; i < 5; i++) {
    const px = ((i * 311 + cameraX * 0.5) % canvasWidth);
    const py = roadY + 30 + (i * 73) % (GROUND_HEIGHT - 50);
    ctx.fillStyle = `rgba(80,100,120,${0.2 + Math.sin(t + i) * 0.05})`;
    ctx.beginPath();
    ctx.ellipse(px, py, 25 + i * 3, 8, 0, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawCracks = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.strokeStyle = 'rgba(80,60,30,0.4)';
  ctx.lineWidth = 1.5;
  for (let i = 0; i < 10; i++) {
    const cx = ((i * 173 + cameraX * 0.6) % canvasWidth);
    const cy = roadY + 20 + (i * 53) % (GROUND_HEIGHT - 30);
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + 15 + (i % 4) * 5, cy + 8 - (i % 3) * 4);
    ctx.lineTo(cx + 30 + (i % 3) * 3, cy + 3);
    ctx.stroke();
  }
};

const drawSandDrifts = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = 'rgba(194,163,102,0.2)';
  for (let i = 0; i < 6; i++) {
    const dx = ((i * 251 + cameraX * 0.4) % canvasWidth);
    const dy = roadY + 20 + (i * 89) % (GROUND_HEIGHT - 30);
    ctx.beginPath();
    ctx.ellipse(dx, dy, 40 + i * 5, 6, 0.1 * i, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawOilStains = (ctx, roadY, canvasWidth, cameraX) => {
  for (let i = 0; i < 4; i++) {
    const ox = ((i * 277 + cameraX * 0.5) % canvasWidth);
    const oy = roadY + 30 + (i * 83) % (GROUND_HEIGHT - 50);
    ctx.fillStyle = 'rgba(20,20,30,0.3)';
    ctx.beginPath();
    ctx.ellipse(ox, oy, 20 + i * 4, 10 + i * 2, 0.3 * i, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawGrates = (ctx, roadY, canvasWidth, cameraX) => {
  const spacing = 300;
  const offset = cameraX % spacing;
  for (let d = -1; d < canvasWidth / spacing + 2; d++) {
    const dx = d * spacing - offset + 50;
    ctx.fillStyle = '#1a1a1a';
    ctx.fillRect(dx, roadY + 12, 25, 8);
    ctx.fillStyle = '#333';
    for (let g = 0; g < 4; g++) {
      ctx.fillRect(dx + 3 + g * 6, roadY + 14, 2, 4);
    }
  }
};

const drawNails = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = '#333';
  for (let i = 0; i < 15; i++) {
    const nx = ((i * 113 + cameraX * 0.7) % canvasWidth);
    const ny = roadY + 15 + (i * 43) % (GROUND_HEIGHT - 20);
    ctx.beginPath();
    ctx.arc(nx, ny, 2, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawRope = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.strokeStyle = 'rgba(139,119,80,0.5)';
  ctx.lineWidth = 3;
  const offset = cameraX % 600;
  for (let r = -1; r < canvasWidth / 600 + 2; r++) {
    const rx = r * 600 - offset;
    ctx.beginPath();
    ctx.moveTo(rx, roadY + 15);
    ctx.quadraticCurveTo(rx + 40, roadY + 25, rx + 80, roadY + 15);
    ctx.stroke();
  }
};

const drawLavaCracks = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  ctx.strokeStyle = `rgba(255,69,0,${0.4 + Math.sin(t * 2) * 0.2})`;
  ctx.lineWidth = 2;
  for (let i = 0; i < 8; i++) {
    const cx = ((i * 191 + cameraX * 0.5) % canvasWidth);
    const cy = roadY + 25 + (i * 61) % (GROUND_HEIGHT - 35);
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + 10 + i * 3, cy + 12);
    ctx.lineTo(cx + 25, cy + 5);
    ctx.stroke();
  }
  // Ember glow
  ctx.fillStyle = `rgba(255,100,0,${0.15 + Math.sin(t * 3) * 0.1})`;
  for (let i = 0; i < 4; i++) {
    const ex = ((i * 307 + cameraX * 0.4) % canvasWidth);
    const ey = roadY + 30 + (i * 97) % (GROUND_HEIGHT - 50);
    ctx.beginPath();
    ctx.arc(ex, ey, 8 + Math.sin(t + i) * 3, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawHoloStrips = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  const spacing = 200;
  const offset = cameraX % spacing;
  for (let i = -1; i < canvasWidth / spacing + 2; i++) {
    const hx = i * spacing - offset;
    const hue = ((hx + t * 50) % 360 + 360) % 360;
    ctx.fillStyle = `hsla(${hue}, 100%, 60%, 0.15)`;
    ctx.fillRect(hx, roadY + 70, 80, 3);
    ctx.fillRect(hx + 40, roadY + 100, 60, 3);
  }
};

const drawIceCracks = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.strokeStyle = 'rgba(200,230,255,0.4)';
  ctx.lineWidth = 1;
  for (let i = 0; i < 12; i++) {
    const cx = ((i * 137 + cameraX * 0.6) % canvasWidth);
    const cy = roadY + 20 + (i * 47) % (GROUND_HEIGHT - 30);
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    const branches = 2 + (i % 3);
    for (let b = 0; b < branches; b++) {
      const angle = (b / branches) * Math.PI - Math.PI / 2 + (i % 5) * 0.2;
      ctx.lineTo(cx + Math.cos(angle) * 20, cy + Math.sin(angle) * 15);
      ctx.moveTo(cx, cy);
    }
    ctx.stroke();
  }
};

const drawFootprints = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = 'rgba(150,150,180,0.12)';
  for (let i = 0; i < 8; i++) {
    const fx = ((i * 157 + cameraX * 0.5) % canvasWidth);
    const fy = roadY + 30 + (i * 67) % (GROUND_HEIGHT - 40);
    ctx.beginPath();
    ctx.ellipse(fx, fy, 5, 8, 0.2 * (i % 3), 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawRoots = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.strokeStyle = 'rgba(60,40,20,0.5)';
  ctx.lineWidth = 3;
  for (let i = 0; i < 6; i++) {
    const rx = ((i * 223 + cameraX * 0.4) % canvasWidth);
    const ry = roadY + 15 + (i * 71) % (GROUND_HEIGHT - 30);
    ctx.beginPath();
    ctx.moveTo(rx, ry);
    ctx.quadraticCurveTo(rx + 20, ry + 10, rx + 40, ry - 5);
    ctx.stroke();
  }
};

const drawBubbles = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  for (let i = 0; i < 5; i++) {
    const bx = ((i * 283 + cameraX * 0.3) % canvasWidth);
    const by = roadY + 40 + (i * 79) % (GROUND_HEIGHT - 60);
    const r = 3 + Math.sin(t * 2 + i) * 1.5;
    ctx.fillStyle = `rgba(60,80,40,${0.2 + Math.sin(t + i) * 0.1})`;
    ctx.beginPath();
    ctx.arc(bx, by, r, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawRivets = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = 'rgba(100,110,120,0.5)';
  for (let i = 0; i < 20; i++) {
    const rx = ((i * 97 + cameraX * 0.7) % canvasWidth);
    const ry = roadY + 15 + (i * 37) % (GROUND_HEIGHT - 20);
    ctx.beginPath();
    ctx.arc(rx, ry, 2.5, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawLights = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  const spacing = 150;
  const offset = cameraX % spacing;
  for (let i = -1; i < canvasWidth / spacing + 2; i++) {
    const lx = i * spacing - offset + 75;
    const on = Math.sin(t * 3 + i) > 0;
    ctx.fillStyle = on ? 'rgba(0,255,255,0.3)' : 'rgba(0,50,50,0.2)';
    ctx.beginPath();
    ctx.arc(lx, roadY + 20, 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = on ? 'rgba(255,0,100,0.3)' : 'rgba(50,0,20,0.2)';
    ctx.beginPath();
    ctx.arc(lx, roadY + GROUND_HEIGHT - 15, 4, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawMoss = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = 'rgba(34,100,34,0.25)';
  for (let i = 0; i < 8; i++) {
    const mx = ((i * 199 + cameraX * 0.5) % canvasWidth);
    const my = roadY + 12 + (i * 59) % (GROUND_HEIGHT - 20);
    ctx.beginPath();
    ctx.ellipse(mx, my, 10 + i * 2, 4, 0, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawRubble = (ctx, roadY, canvasWidth, cameraX) => {
  ctx.fillStyle = 'rgba(80,80,80,0.4)';
  for (let i = 0; i < 10; i++) {
    const rx = ((i * 167 + cameraX * 0.5) % canvasWidth);
    const ry = roadY + 20 + (i * 57) % (GROUND_HEIGHT - 30);
    const size = 4 + (i % 4) * 2;
    ctx.fillRect(rx, ry, size, size * 0.7);
  }
};

const drawCrystals = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  for (let i = 0; i < 6; i++) {
    const cx = ((i * 241 + cameraX * 0.4) % canvasWidth);
    const cy = roadY + 25 + (i * 83) % (GROUND_HEIGHT - 40);
    const h = 10 + (i % 3) * 5;
    ctx.fillStyle = `rgba(153,69,255,${0.2 + Math.sin(t + i) * 0.1})`;
    ctx.beginPath();
    ctx.moveTo(cx, cy); ctx.lineTo(cx + 4, cy - h);
    ctx.lineTo(cx + 8, cy); ctx.closePath();
    ctx.fill();
  }
};

const drawFlames = (ctx, roadY, canvasWidth, cameraX) => {
  const t = Date.now() / 1000;
  for (let i = 0; i < 6; i++) {
    const fx = ((i * 229 + cameraX * 0.3) % canvasWidth);
    const fy = roadY + GROUND_HEIGHT - 15;
    const h = 15 + Math.sin(t * 5 + i) * 8;
    ctx.fillStyle = `rgba(255,${50 + i * 20},0,${0.3 + Math.sin(t * 4 + i) * 0.1})`;
    ctx.beginPath();
    ctx.moveTo(fx - 5, fy); ctx.lineTo(fx, fy - h);
    ctx.lineTo(fx + 5, fy); ctx.closePath();
    ctx.fill();
  }
};

// Detail function map
const DETAIL_DRAWERS = {
  manholes: drawManholes,
  puddles: drawPuddles,
  cracks: drawCracks,
  sand_drifts: drawSandDrifts,
  oil_stains: drawOilStains,
  grates: drawGrates,
  nails: drawNails,
  rope: drawRope,
  lava_cracks: drawLavaCracks,
  holo_strips: drawHoloStrips,
  ice_cracks: drawIceCracks,
  footprints: drawFootprints,
  roots: drawRoots,
  bubbles: drawBubbles,
  rivets: drawRivets,
  lights: drawLights,
  moss: drawMoss,
  rubble: drawRubble,
  crystals: drawCrystals,
  flames: drawFlames,
};

// Marking function map
const MARKING_DRAWERS = {
  road: drawRoadMarkings,
  road_faded: drawFadedRoadMarkings,
  cobblestone: drawCobblestone,
  planks: drawPlanks,
  hazard: drawHazardMarkings,
  neon_road: drawNeonRoad,
  circuit: drawCircuitMarkings,
  stone_tiles: drawStoneTiles,
  grid: drawGrid,
  broken_road: drawBrokenRoad,
  tire_tracks: drawTireTracks,
  ritual: drawRitualMarkings,
};

// === Main draw function ===

export const drawGround = (ctx, cameraX, canvasWidth, canvasHeight, level) => {
  const theme = getTheme(level);
  const roadY = canvasHeight - GROUND_HEIGHT;

  // Curb / border at top
  ctx.fillStyle = theme.curb;
  ctx.fillRect(0, roadY, canvasWidth, 10);
  ctx.fillStyle = theme.surface[0];
  ctx.fillRect(0, roadY, canvasWidth, 3);

  // Main surface with depth gradient
  const surfaceGrad = ctx.createLinearGradient(0, roadY + 10, 0, canvasHeight);
  surfaceGrad.addColorStop(0, theme.surface[0]);
  surfaceGrad.addColorStop(0.5, theme.surface[1]);
  surfaceGrad.addColorStop(1, theme.surface[2]);
  ctx.fillStyle = surfaceGrad;
  ctx.fillRect(0, roadY + 10, canvasWidth, GROUND_HEIGHT - 10);

  // Surface grain
  drawGrain(ctx, roadY, canvasWidth, cameraX, theme);

  // Markings
  if (theme.markings !== 'none') {
    const markingFn = MARKING_DRAWERS[theme.markings];
    if (markingFn) markingFn(ctx, roadY, canvasWidth, cameraX, theme);
  }

  // Details
  const detailFn = DETAIL_DRAWERS[theme.details];
  if (detailFn) detailFn(ctx, roadY, canvasWidth, cameraX);

  // Top edge glow
  ctx.strokeStyle = theme.edgeGlow;
  ctx.lineWidth = 2;
  ctx.shadowColor = theme.edgeGlow;
  ctx.shadowBlur = 10;
  ctx.beginPath();
  ctx.moveTo(0, roadY);
  ctx.lineTo(canvasWidth, roadY);
  ctx.stroke();
  ctx.shadowBlur = 0;

  // Bottom edge
  ctx.strokeStyle = theme.curb;
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(0, canvasHeight - 2);
  ctx.lineTo(canvasWidth, canvasHeight - 2);
  ctx.stroke();
};

export default drawGround;
